import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ckUpdatePack, ceTogglePack, packEntrepreneurChoosePack } from '../../../redux/actions/checkout_operations';
import {
  lpPattern, P_SELECT_PACK_1, P_SELECT_PACK_2,
} from '../../../tracking/pattern_detector';
import Faq from './faq';
import lpApp from '../../../app/lp_app';
import PackEntrepreneurAB from '../upsell/pack-entrepreneurAB'
import { packEntrepreneurData } from '../upsell/pack-entrepreneurAB-Data';


class _TwoColumnsPack extends Component {
  constructor(props) {
    super(props);

    this.onChoose = this.onChoose.bind(this);
    this.state = {
      packs: _TwoColumnsPack.getPacksFeatures(),
      packNames: this.getPackInfo(),
    };
  }
  
  chooseButtonToClick = (e) => {
    if (Object.keys(packEntrepreneurData).indexOf((lpApp.contractMetaId).toString()) > -1) {
    const index = +(e.target.attributes['data-pack'].value)
    this.props.onPackEntrepreneurChoosePack(index)
    } else {
      this.onChoose(e)
    }
  }

  onChooseNewAbTest = (id) => {
    const chosenPack = id;
    if (chosenPack === 1) {
      this.props.selectOne();
    }
    else this.props.selectTwo();
    this.props.togglePack(true);
  }
  

  onChoose(e) {
    const chosenPack = +(e.target.attributes['data-pack'].value);
    if (chosenPack === 1) {
      this.props.selectOne();
    }
    else this.props.selectTwo();
    this.props.togglePack(true);
  }

  getPackInfo() {
    switch (lpApp.contractMetaId) {
      /*
             * Checkout Association
             */
      case 162:
        return [
          {
            title: 'Statuts seuls',
            sub: 'Vous créez seul',
            price: `${this.props.second_price}€`,
            fees: true,
          },
          {
            title: 'Création Express',
            sub: "On s'occupe de tout",
            price: `${this.props.first_price}€`,
            fees: true,
          },
        ];
        case 181:
          return [
            {
              title: 'Création Standard',
              sub: "On s'occupe de tout",
              price: `${this.props.second_price}€`,
              fees: true,
            },
            {
              title: 'Création Express',
              sub: 'Traité sous 24H',
              price: `${this.props.first_price}€`,
              fees: true,
            },
          ];
        // Changement de siège social
        case 227:
          return [
            {
              title: 'Pack Standard',
              price: `${this.props.second_price}€`,
              fees: '+ frais administratifs (352€)',
            },
            {
              title: 'Pack Express',
              price: `${this.props.first_price}€`,
              fees: '+ frais administratifs (352€)',
            },
          ];
      case 219:
        return [
        {
          title: "Radiation standard",
          sub: "",
          price: this.props.second_price + "€",
          fees: false
        },
        {
          title: "Radiation express",
          sub: "",
          price: this.props.first_price + "€",
          fees: false
        }
        ];
      case 230:
        return [
          {
            title: 'Moins de 50 salariés',
            sub: '',
            price: this.props.second_price + "€",
            fees: 'Procédure complète avec vote 100% en ligne'
          },
          {
            title: 'Plus de 50 salariés',
            sub: '',
            price: this.props.first_price + "€",
            fees: 'Procédure complète avec vote 100% en ligne'
          }
        ];
      case 231:
        return [
          {
            title: 'Élection classique',
            sub: '',
            price: this.props.second_price + "€",
            fees: 'Procédure complète avec vote sous enveloppes dans vos locaux'
          },
          {
            title: 'Élection digitalisée',
            sub: '',
            price: this.props.first_price + "€",
            fees: 'Procédure complète avec vote 100% en ligne\n\n' // Break line added to align with the other pack
          }
        ];
        // changement-denomination-sociale
        case 287:
          return [
            {
              title: 'Pack Standard',
              price: `${this.props.second_price}€`,
              fees: '+ frais administratifs (343€)',
            },
            {
              title: 'Pack Express',
              price: `${this.props.first_price}€`,
              fees: '+ frais administratifs (343€)',
            },
          ];

        // Changement d'objet de société
        case 296:
          return [
            {
              title: 'Pack Standard',
              price: `${this.props.second_price}€`,
              fees: '+ frais administratifs (320€)',
            },
            {
              title: 'Pack Express',
              price: `${this.props.first_price}€`,
              fees: '+ frais administratifs (320€)',
            },
          ];

        // modifier-date-cloture-ex-social
        case 301:
          return [
            {
              title: 'Pack Standard',
              price: `${this.props.second_price}€`,
              fees: '+ frais administratifs (80€)',
            },
            {
              title: 'Pack Express',
              price: `${this.props.first_price}€`,
              fees: '+ frais administratifs (80€)',
            },
          ];
        // Changement de siège social EXT
        case 616:
          return [
            {
              title: 'Pack Standard',
              price: `${this.props.second_price}€`,
              fees: '+ frais administratifs (517,56€)',
            },
            {
              title: 'Pack Express',
              price: `${this.props.first_price}€`,
              fees: '+ frais administratifs (517,56€)',
            },
          ];
      default:
        break;
    }
  }


  static getPacksFeatures() {
    switch (lpApp.contractMetaId) {
      /*
             */
      /* Checkout Association */
      case 162:
        return [
          {
            title: 'Statuts ',
            dynamic: true,
            isTitle: true,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: "Enregistrement de l'association",
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          }, {
            title: 'Échanges avec la préfecture',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          }, {
            title: 'Assistance obtention du SIRET',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          }, {
            title: 'Assistance téléphonique illimitée',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          }, {
            title: 'Traitement express (24h)',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          },
        ];
        case 181:
        return [
          {
            title: 'Dossier juridique complet',
            dynamic: false,
            isTitle: true,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Gérer les formalités administratives',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Obtention du numéro SIRET',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Assistance téléphonique illimitée',
            isTitle: false,
            isSpacer: true,
            checks: [true, true],
          }, {
            title: 'Traitement express (24h)',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          }, {
            title: 'Obtention de l\'ACRE (ex ACCRE)',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          },
        ];
      // Changement de siège social
      case 227:
        return [
          {
            title: 'Vérification de votre dossier par un expert LegalPlace',
            dynamic: false,
            isTitle: true,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Validation et transmission de votre dossier au greffe',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Kbis mis à jour',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Mise à jour de la déclaration des bénéficiaires effectifs',
            isTitle: false,
            isSpacer: true,
            checks: [true, true],
          }, {
            title: 'Assitance téléphonique illimitée',
            isTitle: false,
            isSpacer: true,
            checks: [true, true],
          }, {
            title: 'Traitement express (24h)',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          },
        ];
        case 219:
          return [
          {
            title: "Dossier juridique complet",
            dynamic: false,
            isTitle: true,
            isSpacer: false,
            checks: [true, true]
          },{
            title: "Revue et validation de votre dossier par un formaliste",
            isTitle: false,
            isSpacer: false,
            checks: [true, true]
          },{
            title: "Dépot de votre dossier auprès du greffe ou du CFE",
            isTitle: false,
            isSpacer: false,
            checks: [true, true]
          },{
            title: "Gestion des échanges avec le greffe ou le CFE",
            isTitle: false,
            isSpacer: true,
            checks: [true, true]
          },{
            title: "Assistance téléphonique illimitée",
            isTitle: false,
            isSpacer: false,
            checks: [false, true]
          },{
            title: "Gestion express (moins de 48h)",
            isTitle: false,
            isSpacer: false,
            checks: [false, true]
          }
          ];
        case 230:
          return [
            {
              title: 'Rétroplanning',
              dynamic: false,
              isTitle: false,
              isSpacer: false,
              checks: [true, true]
            },
            {
              title: 'Tous vos documents légaux sur-mesure',
              isTitle: false,
              isSpacer: false,
              checks: [true, true]
            },
            {
              title: 'Suivi de votre procédure par un expert',
              isTitle: false,
              isSpacer: false,
              checks: [true, true]
            },
            {
              title: 'Assistance téléphonique',
              isTitle: false,
              isSpacer: false,
              checks: [true, true]
            },
            {
              title: 'Prise en charge totale de vos élections par vote électronique',
              isTitle: false,
              isSpacer: false,
              checks: [true, true]
            }
          ]
        case 231:
          return [
            {
              title: 'Rétroplanning',
              dynamic: false,
              isTitle: false,
              isSpacer: false,
              checks: [true, true]
            },
            {
              title: 'Tous vos documents légaux sur-mesure',
              isTitle: false,
              isSpacer: false,
              checks: [true, true]
            },
            {
              title: 'Suivi de votre procédure par un expert',
              isTitle: false,
              isSpacer: false,
              checks: [true, true]
            },
            {
              title: 'Assistance téléphonique',
              isTitle: false,
              isSpacer: false,
              checks: [true, true]
            },
            {
              title: 'Guide complet sur la marche à suivre pour l\'organisation de vos éléctions',
              isTitle: false,
              isSpacer: false,
              checks: [true, false]
            },
            {
              title: 'Scrutin réalisé par vote électronique',
              isTitle: false,
              isSpacer: false,
              checks: [false, true]
            }
          ]
      // changement-denomination-sociale
      case 287:
        return [
          {
            title: 'Vérification de votre dossier par un expert LegalPlace',
            dynamic: false,
            isTitle: true,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Validation et transmission de votre dossier au greffe',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Kbis mis à jour',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Mise à jour de la déclaration des bénéficiaires effectifs',
            isTitle: false,
            isSpacer: true,
            checks: [true, true],
          }, {
            title: 'Assitance téléphonique illimitée',
            isTitle: false,
            isSpacer: true,
            checks: [true, true],
          }, {
            title: 'Traitement express (24h)',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          },
        ]
      // Changement d'objet de société
      case 296:
        return [
          {
            title: 'Vérification de votre dossier par un expert LegalPlace',
            dynamic: false,
            isTitle: true,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Validation et transmission de votre dossier au greffe',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Kbis mis à jour',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Assitance téléphonique illimitée',
            isTitle: false,
            isSpacer: true,
            checks: [true, true],
          }, {
            title: 'Traitement express (24h)',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          },
        ];
      // modifier-date-cloture-ex-social
      case 301:
        return [
          {
            title: 'Vérification de votre dossier par un expert LegalPlace',
            dynamic: false,
            isTitle: true,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Validation et transmission de votre dossier au greffe',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Kbis mis à jour',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          },  {
            title: 'Assitance téléphonique illimitée',
            isTitle: false,
            isSpacer: true,
            checks: [true, true],
          }, {
            title: 'Traitement express (24h)',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          },
        ]
      // Changement de siège social EXT
      case 616:
        return [
          {
            title: 'Vérification de votre dossier par un expert LegalPlace',
            dynamic: false,
            isTitle: true,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Validation et transmission de votre dossier au greffe',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Kbis mis à jour',
            isTitle: false,
            isSpacer: false,
            checks: [true, true],
          }, {
            title: 'Mise à jour de la déclaration des bénéficiaires effectifs',
            isTitle: false,
            isSpacer: true,
            checks: [true, true],
          }, {
            title: 'Assitance téléphonique illimitée',
            isTitle: false,
            isSpacer: true,
            checks: [true, true],
          }, {
            title: 'Traitement express (24h)',
            isTitle: false,
            isSpacer: false,
            checks: [false, true],
          },
        ];
      default:
        return null;
    }
  }

  render() {
    const getContractName = (contractMetaId) => {
      switch (contractMetaId) {
        case 162:
          return 'association';
        case 181:
          return 'auto entreprise';
        case 219:
          return "Radiation d'Auto-Entreprise";
        case 230:
          return 'Élection du CSE';
        case 231:
          return '';
        default:
          break;
      }
    };

    const getContractTitle = (contractMetaId) => {
      switch (contractMetaId) {
        case 219:
          return {
            title: "Votre cessation d’activité est presque prête",
            subTitle: 'Choisissez votre pack, nous gérons ensuite toutes les démarches'
          };
        case 230:
          return {
            title: 'Élection du CSE',
            subTitle: 'Choisissez votre pack en fonction de la taille de votre entreprise'
          };
        case 231:
          return {
            title: 'Élection du CSE de votre société',
            subTitle: 'Choisissez votre niveau d’accompagnement'
          };
        // Changement de siège social
        case 227:
          return {
            title: `Votre changement de siège social est prêt`,
            subTitle: 'Choisissez votre pack, nous gérons ensuite toutes les démarches'
          };
        // Changement de siège social EXT
        case 616:
          return {
            title: `Votre changement de siège social est prêt`,
            subTitle: 'Choisissez votre pack, nous gérons ensuite toutes les démarches'
          };

        // modifier-date-cloture-ex-social
        case 301:
          return {
            title: `Votre modification de la date de clôture \nde l'exercice social est prête`,
            subTitle: 'Choisissez votre pack, nous gérons ensuite toutes les démarches'
          };

        // changement-denomination-sociale
        case 287:
          return {
            title: `Votre changement de dénomination sociale est prêt`,
            subTitle: 'Choisissez votre pack, nous gérons ensuite toutes les démarches'
          };

        // Changement d'objet de société
        case 296:
          return {
            title: `Votre modification d'objet social est prête`,
            subTitle: 'Choisissez votre pack, nous gérons ensuite toutes les démarches'
          };

        default:
          return {
            title: `Votre ${getContractName(lpApp.contractMetaId)} est prête à être créée`,
            subTitle: 'Choisissez votre pack, nous gérons ensuite toutes les démarches'
          }
      }
    };

    const getPackInfo = (packIndex) => {
      const packList = [];
      this.state.packs.forEach((opt, i) => {
        if (opt.checks[packIndex] === true) {
          let className = '';

          if (opt.isTitle) {
            className = 'is-title';
          } else if (opt.isSpacer) {
            className = 'is-spacer';
          }
          const li = (
            <li key={`cemobpck-${i}`} className={className}>
              <i className="icn-checkmark" />
              {(opt.dynamic)
                ? (
                  <span>
                    {opt.title}
                    {' '}
                    {(packIndex === 0) ? `d'${getContractName(lpApp.contractMetaId)}` : ''}
                    {' '}
                    {(packIndex === 1) ? '+ dossier complet' : ''}
                    {' '}
                  </span>
                )
                : (
                  <span>
                    {opt.title}
                    {' '}
                  </span>
                )}
            </li>
          );
          packList.push(li);
        }
      });

      return packList;
    };
    const { packEntrepreneurPack } = this.props
    if (typeof packEntrepreneurPack !== 'undefined') {return <PackEntrepreneurAB selectPack={this.onChooseNewAbTest}  index={packEntrepreneurPack}/>}
    return (
      <div>
        <section>
          <div className="container">
            <div className="sc-heading">
              <h1 className="sc-title">{getContractTitle(lpApp.contractMetaId).title}</h1>
              <p className="sc-stitle">{getContractTitle(lpApp.contractMetaId).subTitle}</p>
            </div>
            <div>
              <ul className="pricing-table-x5 pt-x5-2">
                <li className="pt-pack">
                  <div className="pack-head">
                    <h2 className="pack-title">{this.state.packNames[0].title}</h2>
                    <span className="pack-stitle">{this.state.packNames[0].sub}</span>
                  </div>
                  <div className="pack-pricing">
                    <h4 className="px-pricing">
                      <div className="price-current">
                        <span className="pp-value">{this.state.packNames[0].price}</span>
                        <span className="pp-tax">HT</span>
                      </div>
                    </h4>
                    <div className="pp-mention">{(this.state.packNames[0].fees) ? this.state.packNames[0].fees : ''}</div>
                  </div>
                  <div className="xcta" href="#" data-pack="2" onClick={this.chooseButtonToClick}>Choisir ce pack</div>
                  <ul className="pack-features">
                    {getPackInfo(0)}
                  </ul>
                </li>
                <li className={`pt-pack ${this.props.shouldNotHaveMostPopularPack ? '' : 'pt-premium'}`}>
                  {!this.props.shouldNotHaveMostPopularPack && (<div className="pack-premium-mention"><div>Le  plus populaire</div></div>)}
                  <div className="pack-head">
                    <h2 className="pack-title">{this.state.packNames[1].title}</h2>
                    <span className="pack-stitle">{this.state.packNames[1].sub}</span>
                  </div>
                  <div className="pack-pricing">
                    <h4 className="px-pricing">
                     <div className="price-current">
                        <span className="pp-value">{this.state.packNames[1].price}</span>
                        <span className="pp-tax">HT</span>
                      </div>
                    </h4>
                    <div className="pp-mention">{(this.state.packNames[1].fees) ? this.state.packNames[1].fees : ''}</div>
                  </div>
                  <div className="xcta" href="#" data-pack="1" onClick={this.chooseButtonToClick}>Choisir ce pack</div>
                  <ul className="pack-features">
                    {getPackInfo(1)}
                  </ul>
                </li>
              </ul>
              {(!this.props.removeReassurance) && (<div className="marketing-args">
                <div className="flex-media checkout-assistance">
                  <div className="fm-obj">
                    <img src="/wizard/img/ma-phone.svg" />
                  </div>
                  <div className="fm-body">
                    <div className="fm-title">Assistance Téléphonique</div>
                    <div className="fm-stitle">Pour tout renseignement</div>
                  </div>
                </div>
                <div className="flex-media x3-payement">
                  <div className="fm-obj">
                    <img src="/wizard/img/ma-euro.svg" />
                  </div>
                  <div className="fm-body">
                    <div className="fm-title">Payez en 3 fois</div>
                    <div className="fm-stitle">Sans frais suplémentaires</div>
                  </div>
                </div>
                <div className="flex-media wg-avis">
                  <div className="fm-obj">
                    <img src="/wizard/img/ma-avis.svg" />
                  </div>
                  <div className="fm-body">
                    <div className="fm-title">Satisfaction Garantie</div>
                    <div className="fm-content">
                      <div className="rb-stars">
                        <span className="icn-star-full" />
                        <span className="icn-star-full" />
                        <span className="icn-star-full" />
                        <span className="icn-star-full" />
                        <span className="icn-star-half" />
                      </div>
                      <div className="wa-avis"><a target="_blank" rel="noopener noreferrer" href="https://fr.trustpilot.com/review/legalplace.fr">sur 451 avis</a></div>
                    </div>
                  </div>
                </div>
              </div>)}
            </div>
          </div>
        </section>
        {([219, 227, 287, 296, 301, 616].indexOf(lpApp.contractMetaId) === -1) ?
          <Faq />
          : ""}
        </div>
    );
  }
}


const mapStateToProps = state => ({
  first_price: state.checkout_operations.prices.first_price,
  second_price: state.checkout_operations.prices.second_price,
  third_price: state.checkout_operations.prices.third_price,
  chosen_pack: state.checkout_operations.pack,
  pricing_loading: state.loading_details.pricing,
  promo_percentage: state.checkout_operations.promo_percentage,
  packEntrepreneurPack: state.checkout_operations.packEntrepreneur.choosePack,
  title: state.contract.name,
});

const mapDispatchToProps = dispatch => ({
  togglePack: (val) => {
    dispatch(ceTogglePack(val));
  },
  selectOne: () => {
    dispatch(ckUpdatePack(0));
    lpPattern.trackInPayment(P_SELECT_PACK_1);
  },
  selectTwo: () => {
    dispatch(ckUpdatePack(1));
    lpPattern.trackInPayment(P_SELECT_PACK_2);
  },
  onPackEntrepreneurChoosePack: (val) => {
    dispatch(packEntrepreneurChoosePack(val));
  },
});

const TwoColumnsPack = connect(mapStateToProps, mapDispatchToProps)(_TwoColumnsPack);

export default TwoColumnsPack;



// WEBPACK FOOTER //
// ./src/components/buy/table-checkouts/twoColumnsPack.js